module.exports = __webpack_public_path__ + "img/DrinkCoach-logo.bfc865d4.svg";